













































import { Component, Mixins } from "vue-property-decorator";
import { EditConfirmDialogMixin } from "./mixins";

@Component
export default class EditConfirmDialog extends Mixins(EditConfirmDialogMixin) {
}
